export default __webpack_public_path__ + "static/media/alert-icon.02652614.svg";